import { render, staticRenderFns } from "./ResetPasswordComponent.vue?vue&type=template&id=329a8722"
import script from "./ResetPasswordComponent.js?vue&type=script&lang=js&external"
export * from "./ResetPasswordComponent.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports